import { StyleSheet } from 'react-native';

export const tableStyles = theme =>
  StyleSheet.create({
    container: {
      marginTop: 20
    },
    tableWrap: { marginTop: 16 },
    tableContainer: { borderWidth: 0, flex: 1, borderRadius: 8 },
    rowContainer: {
      justifyContent: 'space-between',
      borderBottomColor: theme.palette.primaryBackgroundLow,
      minHeight: 48,
      height: 'auto'
    },
    headerContainer: {
      borderBottomColor: theme.palette.primaryOutline,
      justifyContent: 'space-between'
    },
    lastRowStyle: { borderBottomWidth: 0 }
  });

export const tableCellStyles = theme =>
  StyleSheet.create({
    headerContainer: {
      backgroundColor: theme.palette.primaryBackgroundLow,
      borderBottomWidth: 0,
      borderTopStartRadius: 8,
      borderTopEndRadius: 8,
      paddingHorizontal: 0
    },
    rowWrap: {
      borderBottomColor: theme.palette.borderColor,
      flex: 1,
      flexDirection: 'row',
      alignItems: 'center',
      paddingVertical: 10,
      paddingRight: 20,
      gap: 10
    },
    lastRow: { borderBottomWidth: 0 },
    firstColumn: { paddingStart: 8 },
    headerWrap: { flex: 1, paddingVertical: 8 }
  });
